import colors from "../../template/Colors";

const styles = {
    fullPage : {
        backgroundColor: colors.charcoal,
        color : colors.offWhite,
    },
    pageMainContentContainer : {
        display : 'flex',
        flexDirection : 'row',
    },
    portfolioSidebar : {
        boxSizing : 'border-box',
        position : 'sticky',
        top : 0,
        width : '16rem',
        padding : '2rem 1rem 1rem 2rem',
        borderRight : 'solid 1px',
        height : '100vh'
    },
    sidebarJumpToSectionButton : {
        display : 'block',
        width : '100%',
        textAlign: 'left',
        background : 'none',
        border : 'none',
        color : colors.lightGray,
        padding : '0.5rem 1rem',
        margin : '0rem 0rem',
        fontSize : '1.2rem',
        fontWeight : '300',
        '&:hover' : {
            textDecoration: 'underline',
            cursor : 'pointer',
            color : 'white'
        }
    },
    currentSidebarJumpToSectionButton : {
        composes : '$sidebarJumpToSectionButton',
        color : colors.offWhite,
        background : colors.gray,
        borderRadius : '0.75rem',
        '&:hover' : {
            color : 'white'
        }
    },
    portfolioContent : {
        width : '100%',
        maxWidth : '70rem',
        padding : '0rem 2rem'
    },
    portfolioOverviewHeader : {
        fontSize : '3.5rem',
        marginBottom : 0
    },
    portfolioOverviewSubheader : {
        fontSize : '2rem',
        marginTop : '0.5rem'
    },
    portfolioOverviewContent : {
        display : 'flex',
        flexDirection : 'row',
        flexWrap : 'wrap',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
    },
    mobilePortfolioOverviewContent : {
        composes : '$portfolioOverviewContent'
    },
    overviewText : {
        boxSizing : 'border-box',
        marginRight : '2rem',
    },
    headshotImage : {
        height : '20rem',
        borderRadius : '50%',
        marginTop : '2rem'
    },

    portfolioContentSection : {
        marginBottom : '3rem',
        '& p' : {
            marginBottom : '0.75rem'
        },
        '& h3' : {
            fontSize : '1.4rem',
            margin : 0,
            marginBottom : '0.25rem',
            fontWeight : '400'
        },
        '& ul' : {
            margin : '0.25rem 0rem'
        }
    },
    portfolioSectionHeader : {
        fontSize : '2.5rem',
        marginBottom : '1rem',
    },
    horizontalBreak : {
        borderTop : '1px solid white'
    },
    portfolioFlexSubsection : {
        maxWidth : '65%'
    },
    mobilePortfolioFlexSubsection : {
        maxWidth : '100%',
        marginBottom : '2rem'
    },
    jobPositionHeader : {
        marginTop: '2.5rem',
        marginBottom: '0.25rem',
    },
    portfolioSectionHorizontalFlex : {
        display : 'flex',
        flexDirection: 'row',
        flexWrap : 'wrap',
        justifyContent : 'space-between',
        alignItems: 'center',
        marginBottom : '1.5rem',
        '& img' : {
            height : '16rem',
            borderRadius : '50%'
        }
    },
    sectionImage : {
        height : '16rem',
        borderRadius : '50%',
        marginTop : '2rem'
    },
    portfolioSectionText : {
        marginRight : '2rem'
    },
    portfolioSectionVerticalFlex : {
        composes : '$portfolioSectionHorizontalFlex',
        flexDirection : 'column'
    },
    '@global' : {
        body : {
            backgroundColor: colors.charcoal
        },
        p : {
            margin : '0.5rem 0rem'
        },
        a : {
            textDecoration: 'underline',
            color : colors.paleBlue,
            '&:hover' : {
                textDecoration: 'none',
                color : colors.azure,
                cursor : 'pointer'
            }
        }
    }
}

export default styles;